import Vue from 'vue'
import Vuex, {
	mapGetters
} from 'vuex'
Vue.use(Vuex)

var prefix = 'vuex-cache';
var vuexKey = 'AXB_USER_';

// 统一的存储函数 - PC端使用 localStorage
const storage = {
	getItem(key) {
		try {
			return localStorage.getItem(key);
		} catch (e) {
			console.error('localStorage get error:', e);
			return null;
		}
	},
	setItem(key, value) {
		try {
			localStorage.setItem(key, value);
		} catch (e) {
			console.error('localStorage set error:', e);
		}
	}
};

// 读取存储数据
const getStoredData = () => {
	try {
		const data = storage.getItem(prefix);
		const timestamp = storage.getItem(prefix + '-timestamp');
		return {
			VuexData: data ? JSON.parse(data) : {},
			VuexDataTimestamp: timestamp ? JSON.parse(timestamp) : {}
		};
	} catch (e) {
		console.error('Storage data parse error:', e);
		return {
			VuexData: {},
			VuexDataTimestamp: {}
		};
	}
};

const {
	VuexData,
	VuexDataTimestamp
} = getStoredData();
let VuexTesting = 0;

// 创建 store 实例
const store = new Vuex.Store({
	state: Object.assign({}, VuexData),
	getters: {
		$getter: state => (name, defval) => {
			name = vuexKey + name;
			let _state = state,
				nameArr = name.split('.');
			for (let _name of nameArr) {
				if (_state[_name]) {
					_state = _state[_name];
				} else {
					return defval || null;
				}
			}
			return _state || null;
		}
	},
	mutations: {
		$vuex(state, payload) {
			if (payload && payload.name && typeof payload.data !== 'undefined') {
				let _state = state,
					nameArr = payload.name.split('.'),
					nameLen = nameArr.length;

				// 构建嵌套对象结构
				for (let index = 0; index < nameLen - 1; index++) {
					if (!_state[nameArr[index]]) {
						_state[nameArr[index]] = {};
					}
					_state = _state[nameArr[index]];
				}

				// 设置最终值
				const finalKey = nameArr[nameLen - 1];
				Vue.set(_state, finalKey, payload.data);

				// 更新存储数据
				const rootKey = nameArr[0];

				if (payload.data === null) {
					// 删除数据
					if (VuexData[rootKey]) {
						delete VuexData[rootKey];
						delete VuexDataTimestamp[rootKey];
						storage.setItem(prefix, JSON.stringify(VuexData));
						storage.setItem(prefix + '-timestamp', JSON.stringify(VuexDataTimestamp));
					}
				} else if (typeof payload.time === 'boolean' && payload.time) {
					// 永久缓存
					VuexData[rootKey] = state[rootKey];
					storage.setItem(prefix, JSON.stringify(VuexData));
				} else if (typeof payload.time === 'number') {
					// 定时缓存
					VuexData[rootKey] = state[rootKey];
					VuexDataTimestamp[rootKey] = (Math.floor(Date.now() / 1000) + parseInt(payload.time))
						.toString();
					storage.setItem(prefix, JSON.stringify(VuexData));
					storage.setItem(prefix + '-timestamp', JSON.stringify(VuexDataTimestamp));
				} else {
					// 不缓存到本地
					VuexData[rootKey] = state[rootKey];
				}
			}
		}
	}
});

// 添加 mixin
Vue.mixin({
	computed: {
		...mapGetters(['$getter']),
	},
	beforeCreate() {
		this.$vuex = (name, value, cache) => {
			name = vuexKey + name;
			if (value) {
				return this.$store.commit('$vuex', {
					name: name,
					data: value,
					time: cache
				});
			} else if (name) {
				let _state = this.$store.state;
				for (let _name of name.split('.')) {
					if (_state[_name]) {
						_state = _state[_name];
					} else {
						return null;
					}
				}
				return _state;
			} else {
				return this.$store.state;
			}
		};
	},
	mounted: function() {
		const currentTime = Math.floor(Date.now() / 1000);
		if (parseInt(VuexTesting) !== currentTime) {
			for (let name in Object.assign({}, VuexData)) {
				let timestamp = VuexDataTimestamp[name] || null;
				if (timestamp && parseInt(timestamp) < currentTime) {
					delete VuexData[name];
					delete VuexDataTimestamp[name];
					this.$store.commit('$vuex', {
						name: name,
						data: null
					});
				}
			}
			VuexTesting = currentTime;
		}
	},
});

export {
	store
};